import { useRef } from 'react';

import cn from 'classnames/bind';
import { merge } from 'lodash-es';
import Head from 'next/head';
import { Col, Container, Row, SEO } from 'ui';
import FaqList from 'ui/components/blog/FaqList';
import MainTestHeader from 'ui/components/tests/MainTestHeader';
import TestWrapper from 'ui/components/tests/TestWrapper';
import mainTestSchema from 'ui/testSchemas/main';
import { host } from 'utils/jsonLd/utils';
import getJsonLdWebPage from 'utils/jsonLd/webPage';

import s from './Test.module.scss';


const cx = cn.bind(s);
const meta = {
  title: "Free Personality Test (16 Personality Types)",
  description: "Take our free personality type test to learn who you truly are, discover your unique strengths and weaknesses, and unleash your full potential!",
  keywords: 'free, personality, test'
}

const FreePersonalityTest = ({ submit, faqItems = [], redirectTo = 'result', onSubmit }) => {
  const contentRef = useRef(null);
  const schema = merge(mainTestSchema, {
    meta: {
      result: {
        path: redirectTo
      }
    }
  })

  const jsonLd = getJsonLdWebPage({name:'Free personality test', description: meta.description, url: `${host}/free-personality-test`})
  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          key="product-jsonld"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd)
          }}
        />
      </Head>
      <SEO
        title={meta.title}
        description={meta.description}
        keywords={[meta.keywords]}
      />
      <div className={cx('wrapper')}>
        <MainTestHeader />
        <main ref={contentRef} className={cx('content')}>
          <TestWrapper
            schema={schema}
            schemaName="main"
            submit={submit}
            onSubmit={onSubmit}
          />
        </main>
      </div>
      {!!faqItems.length && (
        <Container className={cx('faqContainer')}>
          <Row>
            <Col>
              <FaqList items={faqItems} title="Personality Test FAQ" />
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
};

FreePersonalityTest.prettyName = 'Free Personality Test';

export default FreePersonalityTest;
